import { Upload, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { InputWrapper, SplitInputWrapperProps } from "../../functions";
import { validations } from "../../../../config/validations/validations";
import { useEffect, useState } from "react";
import { IMAGE_UPLOAD } from "../../../../config/Constant";
import CommonModal from "../../../Modals/CommonModal";
import { RcFile } from "antd/es/upload";
import React from "react";

const ImageUploadInputBox: React.FC<any> = (props) => {
  const { formProps, inputProps } = SplitInputWrapperProps(props);
  const [previewImage, setPreviewImage] = useState("");

  const [previewOpen, setPreviewOpen] = useState(false);

  const [fileList, setFileList] = useState<any>([]);
  useEffect(() => {
    if (inputProps?.imageUrl) {
      setFileList([
        {
          uid: "-1",
          status: "done",
          url: IMAGE_UPLOAD + inputProps?.imageUrl,
        },
      ]);
    }
  }, [inputProps?.imageUrl]);
  const uploadButton = (
    <div>
      <PlusOutlined />
    </div>
  );

  const onPreview = async (file?: any) => {
    const getBase64 = (file: RcFile) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
      });
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }
    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const checkFileType = (file: any) => {
    const acceptedFormats = [
      "image/svg+xml",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];
    if (!acceptedFormats.includes(file.type)) {
      message.error(`Upload valid image. Only PNG, JPEG, SVG are allowed.`);
      return true;
    } else {
      return false;
    }
  };

  const onChange = (data: any) => {
    if (data.file?.status === "error" || data.file?.status === "uploading" || data.file?.status === "removed") {
      setFileList([]);
    } else {
      setFileList(data.fileList);
    }
  };

  return (
    <>
      <InputWrapper
        rules={formProps.required ? [validations.required.text()] : []}
        {...formProps}
      >
        <Upload
          name={formProps.name}
          accept=".png,.jpeg,.jpg,.svg"
          maxCount={1}
          onPreview={onPreview}
          fileList={fileList}
          onChange={onChange}
          showUploadList={true}
          multiple={false}
          listType="picture-card"
          beforeUpload={checkFileType}
          {...inputProps}
        >
          {fileList.length < 1 && uploadButton}
        </Upload>
      </InputWrapper>
      <CommonModal
        // width={"max"}
        // maxWidth="1024"
        style={{ maxWidth: "1024px", height: "auto" }}
        open={previewOpen}
        // title={previewTitle}
        onCancel={() => setPreviewOpen(false)}
      >
        <img alt="example" src={previewImage} />
      </CommonModal>
    </>
  );
};

export default ImageUploadInputBox;
